export default __webpack_public_path__ + "static/media/patient-profile-img.6dbc9812.png";